import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PlacesAutocomplete from 'react-places-autocomplete';
import {Editor, EditorState, convertToRaw} from 'draft-js';

export default class BasicInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: '',
            descState: EditorState.createEmpty()
        };
        this.onDescChange = this.onDescChange.bind(this);
    }

    handleChange = (address) => {
        this.setState({
            address
        });
    };

    onDescChange(editorState) {
        this.setState({
            descState: editorState
        }, () => {
            this.props.ondescriptionChange(JSON.stringify(convertToRaw(this.state.descState.getCurrentContent())))
        });
    }

    render() {
        const searchOptions = {
            componentRestrictions: {
                country: ['ca']
            }
        }
        return (
            <div className="createride__basicinfo__main">
                <Form.Label className="createride__category__title">Informations De Base</Form.Label>
                <Row>
                    <Col>
                        <Form.Control name="title" placeholder="Titre" type="text" onChange={this.props.ontitleChange} required />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Control name="subtitle" placeholder="Sous-Titre" type="text" onChange={this.props.onsubTitleChange} required />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Editor editorState={this.state.descState} onChange={this.onDescChange} />
                        {/* <Form.Control as="textarea" name="description" placeholder="Description" onChange={this.props.ondescriptionChange} required /> */}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Control name="priceD" type="number" placeholder="Price per Day" onChange={this.props.onpriceDChange} required />
                    </Col>
                    <Col>
                    </Col>
                </Row>

                <Form.Group controlId="formGridAddress1">
                    <PlacesAutocomplete
                        searchOptions={searchOptions}
                        value={this.props.address}
                        onChange={this.props.onaddressChange}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                                <Form.Control
                                    name="address"
                                    required
                                    {...getInputProps({
                                        placeholder: 'Adresse Balade',
                                        className: 'location-search-input',
                                    })}
                                />
                                <div className="autocomplete-dropdown-container">
                                    {loading && <div>Loading...</div>}
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                </Form.Group>
            </div>
        )
    }
}